import { AddOnDto } from 'store/add-ons/types';
import { createAction } from 'typesafe-actions';

export const addAddOn = createAction('ADD_ADDON')<AddOnDto>();

export const removeAddOn = createAction('REMOVE_ADDON')<string>();

export const resetAddOnsState = createAction('RESET_ADDONS_STATE')<undefined>();
